/**
 * @Description:
 * @Author: yanhui.gao
 * @Date: 2019/7/8  10:50
 */

import dbc from '@/api/system/menu';
import dbcAuth from '@/api/authority';
// 设置文件
import setting from '@/config/setting';

export default {
  namespaced: true,
  state: {
    menu: {
      list: [],
      pageNum: 1,
      total: 0,
    },
    // 搜索菜单关键字
    menuKeyword: '',
    sideBarMenu: [],
    // 权限数组
    permissionList: [],
    navs: [],
    navId: '',
  },
  actions: {
    saveNavMenu({ commit, dispatch }, navId) {
      return new Promise(async (resolve) => {
        // store 赋值
        await dispatch(
          'system/db/set',
          {
            dbName: 'sys',
            path: 'nav',
            value: navId,
            user: true,
          },
          { root: true }
        );
        commit('setNavId', navId);
        // end
        resolve();
      });
    },

    navLoad({ commit, dispatch }) {
      return new Promise(async (resolve) => {
        // store 赋值
        const value = await dispatch(
          'system/db/get',
          {
            dbName: 'sys',
            path: 'nav',
            defaultValue: setting.navId,
            user: true,
          },
          { root: true }
        );

        commit('setNavId', value);
        // end
        resolve();
      });
    },

    /**
     *
     * 系统管理-菜单管理
     */

    /**
     * 菜单管理 获取所有菜单数据，数据不分页
     * @param {*} param0
     * @param {*} param
     */
    getMenuList({ commit }, param) {
      return dbc.getMenuList(param).then((content) => {
        commit('setMenuList', content);
      });
    },

    /**
     * 添加一个菜单
     * @param {*} store
     * @param {*} param
     */
    addMenuItem(store, param) {
      return dbc.addMenuItem(param);
    },

    /**
     * 编辑单个菜单
     * @param {*} store
     * @param {*} param
     */
    editMenuItem(store, param) {
      return dbc.editMenuItem(param);
    },

    /**
     * 删除单个菜单项目
     * @param {*} store
     * @param {*} param
     */
    deleteMenuItem(store, param) {
      return dbc.deleteMenuItem(param);
    },

    /**
     * 批量删除多个菜单项目
     * @param {*} store
     * @param {*} param
     */
    deleteMenuItems(store, param) {
      return dbc.deleteMenuItems(param);
    },
    /**
     * 左侧memu菜单数据
     * @param {*} param0
     * @param {*} param
     */
    async getSideBarMenu({ commit }, param) {
      const res = await dbcAuth.checkIsManager();
      return dbc.getSideBarMenu(param).then((content) => {
        const menuList = content.data.menuList;
        if (res.data.isManager !== 1) {
          content.data.menuList = menuList.filter((item) => item.name !== '下属权限');
        }
        commit('setSideBarMenu', content);
      });
    },
  },
  mutations: {
    // 菜单管理
    setMenuList(state, content) {
      state.menu.list = content.list;
    },

    // 左侧memu菜单数据
    setSideBarMenu(state, content) {
      const { menuList, permissionList } = content.data;
      state.sideBarMenu = menuList;
      state.permissionList = permissionList;
    },
    // 设置左侧搜索关键字
    searchMenu(state, keyword) {
      state.menuKeyword = keyword;
    },
    // 设置顶部菜单
    setNavMenu(state, content) {
      state.navs = content;
    },
    setNavId(state, content) {
      state.navId = content;
    },
  },
};
